import { SessionStore } from "./stores/Session";
import { UiStore } from "./stores/UI";
import { Ability } from "@casl/ability";
import { ClientsStore } from "./stores/ClientsStore";

export enum BookingEvents {
  BOOK_PERSONAL_TRAINER_ACTIVE_SUBSCRIPTION = "BOOK_PERSONAL_TRAINER_ACTIVE_SUBSCRIPTION",
  BOOK_PERSONAL_TRAINER_INACTIVE_SUBSCRIPTION = "BOOK_PERSONAL_TRAINER_INACTIVE_SUBSCRIPTION",
}

export type StorageKey = "session" | "currentUser";

export type Stores = {
  session: SessionStore;
  ui: UiStore;
  clientsStore: ClientsStore;
};

export type MenuItemKeys = FixMeLater;

export type FixMeLater = any;

export type RawAbility = {
  subject: string | string[];
  action: string[];
};

export type Role = {
  uid: string;
  name: string;
  acls: RawAbility[];
};

export type UserRole = {
  uid: string;
  name: string;
  acls: Ability;
};

export type User = {
  email: string;
  imageUrl?: string;
  nominative?: string;
  name: string;
  surname: string;
  password?: string;
  id: string;
  subscriptionID?: string;
  stripeID?: string;
  role?: string;
  phone?: string;
  contact_emergency?: string;
  fb?: string;
  ig?: string;
  contact_preference?: string;
  assistance_type?: string;
  address?: string;
  zip_code?: string;
  city?: string;
  state?: string;
  province_state?: string;
  gender?: string;
  birth_date?: string;
  picture?: string;
  periodic_evaluation?: string;
  note?: string;
  createdAt: Date;
  signupCompleted: boolean;
  subscription_status?: string;
  subscription_activation_date?: Date;
  subscription_disactivation_date?: Date;
  subscription_type?: string;
};

export type VimeoVideoCategory = {
  name: string;
  resourceKey: string;
  uri: string;
  projectId: string;
};

export type VideoCategory = {
  id?: string;
  name: string;
  externalId: string;
  resourceKey: string;
  title?: string;
  description?: string;
  order?: number;
  enabled?: boolean;
};

export type Settings = {
  key: string;
  value: string;
};

export enum SettingsEnum {
  CALENDLY_COACHING_SESSION_URL = "CALENDLY_COACHING_SESSION_URL",
  CALENDLY_LIVE_TRAINING_URL = "CALENDLY_LIVE_TRAINING_URL",
  // ZOOM_LONG_LIVE_MEETING_ID = "ZOOM_LONG_LIVE_MEETING_ID",
  // ZOOM_LONG_LIVE_MEETING_PASSCODE = "ZOOM_LONG_LIVE_MEETING_PASSCODE",
  SUPERVISED_WORKOUTS_STEP_1_VIDEO_URL = "SUPERVISED_WORKOUTS_STEP_1_VIDEO_URL",
  SUPERVISED_WORKOUTS_STEP_1_MESSAGE = "SUPERVISED_WORKOUTS_STEP_1_MESSAGE",
  SUPERVISED_WORKOUTS_STEP_2_ZOOM_LINK = "SUPERVISED_WORKOUTS_STEP_2_ZOOM_LINK",
  SUPERVISED_WORKOUTS_STEP_2_MESSAGE = "SUPERVISED_WORKOUTS_STEP_2_MESSAGE",
  SUPERVISED_WORKOUTS_STEP_3_VIDEO_URL = "SUPERVISED_WORKOUTS_STEP_3_VIDEO_URL",
  SUPERVISED_WORKOUTS_STEP_3_MESSAGE = "SUPERVISED_WORKOUTS_STEP_3_MESSAGE",
  SUPERVISED_WORKOUTS_TIMETABLES = "SUPERVISED_WORKOUTS_TIMETABLES",
  WORKOUTS_TIMETABLES = "WORKOUTS_TIMETABLES",
  CALENDLY_BOOK_PERSONAL_TRAINER_ACTIVE_SUBSCRIPTION = "CALENDLY_BOOK_PERSONAL_TRAINER_ACTIVE_SUBSCRIPTION",
  CALENDLY_BOOK_PERSONAL_TRAINER_INACTIVE_SUBSCRIPTION = "CALENDLY_BOOK_PERSONAL_TRAINER_INACTIVE_SUBSCRIPTION",
}

export type Subscription = {
  id: string;
  cancel_at?: Date;
  cancel_at_period_end: boolean;
  canceled_at?: Date;
  created: Date;
  current_period_end: Date;
  current_period_start: Date;
  customer: string;
  days_until_due?: number;
  ended_at?: Date;
  start_date: Date;
  plan: Plan;
};

type Plan = {
  id: string;
  product: string;
  amount: number;
  productName: string;
};

export type Payment = {
  id: string;
  amount: number;
  currency: string;
  created: Date;
  customer: string;
  paid: boolean;
  refunded: boolean;
  status: string;
};
export type Email = {
  id: string;
  username: string;
  data: Date;
  object: string;
  body: string;
  userId: string;
};

export type Comunication = {
  id: string;
  data: Date;
  operator: string;
  comunicationDirection: string;
  duration: string;
  type: string;
  note: string;
  userId: string;
};

export type PersonalObjective = {
  id: string;
  height: string;
  weight: string;
  lean_mass: string;
  data: string;
  breast: string;
  waist: string;
  thigh: string;
  userId: string;
};

export type GenericObjective = {
  id: string;
  title: string;
  description: string;
  data: string;
  checked: string;
  userId: string;
};

export type VimeoVideo = {
  duration: number;
  link: string;
  name: string;
  type: string;
  picture: string;
  resourceKey: string;
};

export type EvaluationObjective = {
  objective: GenericObjective;
  valutation: number;
  comment: string;
};

export type Evaluation = {
  id: string;
  weight: string;
  lean_mass: string;
  breast: string;
  waist: string;
  thigh: string;
  data: string;
  userId: string;
  photo_url: string | null;
  objectives: EvaluationObjective[];
  personalObjective: PersonalObjective;
};

export type Activity = {
  id: number;
  type: string;
  eventMeta: any;
  dateTime: Date;
  externalId?: string;
  userId: User["id"];
  date: string;
  objectType: string;
};

export type Reservation = {
  id: number;
  type: string;
  eventMeta: any;
  dateTime: Date;
  externalId?: string;
  userId: User["id"];
  source: string;
  objectType: string;
};

export type SubscriptionStatus =
  | "active"
  | "disactive"
  | "trial"
  | "trial-expired";
export type Subscriptions = "VDA" | "Prova";

export type CalendarEvent = {
  id: string;
  title: string;
  start: Date;
  end: Date;
  extendedProps: {
    type: string;
    category?: string;
    log?: any;
  };
};

export type SupervisionedWorkoutsTimetable = {
  [dayOfWeek: number]: {
    slot1: {
      from: Date | null;
      to: Date | null;
    };
    slot2: {
      from: Date | null;
      to: Date | null;
    };
  };
};

export enum PlanningType {
  LIVE_WORKOUT = "LIVE_WORKOUT",
  RECORDED_WORKOUT = "RECORDED_WORKOUT",
  NO_WORKOUT = "NO_WORKOUT",
}

export type Planning = {
  id: number;
  type: PlanningType;
  eventMeta?: any;
  dateTime: Date;
  userId: User["id"];
};
